export enum UserSubscriptionStatusEnum {
  DEACTIVATED = "deactivated",
  INTEGRITY_RESTRICTED = "integrity_restricted",
  NEEDS_CERTIFICATION = "needs_certification",
  PENDING_SEAT = "pending_seat",
  SEATED_ACTIVE = "seated_active",
  PAST_DUE = "past_due",
  CANCELING = "canceling",
  CANCELED = "canceled",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
